import React, { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import { Form } from 'antd';
import moment from 'moment';
import DefaultModal from './DefaultModal';
import CreatePlacementTestForm from 'src/pages/Consulting/CreatePlacementTestForm';
import { CREATE_CONSULT_FOR_LEVELTEST } from 'src/operations/mutations/consult';
import { openNotification } from 'src/components/common/Notification';

const CreatePlacementTestModal = ({ visible, onCancel, refetch, campusIdx, ...rest }) => {
  const [form] = Form.useForm();

  const handleCancel = useCallback(() => {
    form.resetFields();
    onCancel();
  }, [form, onCancel]);

  const [createPlacementTest, { loading }] = useMutation(CREATE_CONSULT_FOR_LEVELTEST, {
    onCompleted: async (data) => {
      if (!data?.createConsultForLevelTest?.idx) return;
      openNotification('Placement Test 등록 완료!');
      handleCancel();
      await refetch();
    },
    onError: (error) => {
      console.log('create placement test error', error);
      alert('Placement Test 등록 중 오류가 발생했습니다.');
    },
  });

  const handleSubmit = useCallback(
    ({ phone, student_name, reserve_date, school_grade }) => {
      createPlacementTest({
        variables: {
          campus_idx: Number(campusIdx),
          phone,
          student_name,
          reserve_date: moment(reserve_date).format('YYYY-MM-DD'),
          school_grade,
          ticket_code: 'EVINE-LT',
        },
      });
    },
    [campusIdx, createPlacementTest],
  );

  return visible ? (
    <DefaultModal
      title="Placement Test 등록"
      visible={visible}
      form={form}
      loading={loading}
      popupMode="create"
      ActionCancel={handleCancel}
      width={50}
      {...rest}
    >
      <CreatePlacementTestForm form={form} onFinish={handleSubmit} />
    </DefaultModal>
  ) : null;
};

export default CreatePlacementTestModal;
